/* eslint-disable @typescript-eslint/no-unused-vars */
import {Directive, ElementRef, HostListener, inject} from '@angular/core'

@Directive({
    selector: '[textMask]',
    exportAs: 'textMask',
    standalone: true,
})
export class MaskedInputDirective {
    private inputElement: HTMLInputElement;
    private readonly placeholder = '__/__/____';
    private digits = '';

    private elementRef = inject(ElementRef);

    constructor() {
        this.inputElement = this.elementRef.nativeElement;
        this.inputElement.value = this.placeholder;
        this.setCursorPosition(0);
    }

    @HostListener('input', ['$event'])
    onInput(event: InputEvent): void {
        if (!event.data) return;
        let cursorPosition = this.inputElement.selectionStart ?? 0;
        let formattedValue = this.inputElement.value;

        this.digits = this.inputElement.value.replace(/\D/g, '');
        const typeValue = event.data?.replace(/\D/g, '');

        if (this.digits.length > 8) {
            this.digits = this.digits.substring(0, 8);
        }

        if (typeValue) {
            formattedValue = this.formatDate(this.digits);
        } else {
            cursorPosition -= 1
            formattedValue = formattedValue.replace(event.data ?? '', '')
        }

        this.inputElement.value = formattedValue;
        this.setCursorPosition(this.calculateNewCursorPosition(cursorPosition));
    }

    private formatDate(digits: string): string {
        const formatted = this.placeholder.split('');

        for (let i = 0, j = 0; i < formatted.length && j < digits.length; i++) {
            if (formatted[i] === '_') {
                formatted[i] = digits[j++];
            }
        }

        return formatted.join('');
    }

    private calculateNewCursorPosition(initialPosition: number): number {
        let position = initialPosition;

        while (position < this.inputElement.value.length) {
            const currentValue = this.inputElement.value[position];

            // Salir del bucle si encontramos un dígito o un guion bajo
            if (/\d/.test(currentValue) || currentValue === '_') {
                break;
            }

            position++;
        }

        return position;
    }

    private setCursorPosition(position: number): void {
        this.inputElement.setSelectionRange(position, position);
    }
}
